import debounce from "lodash/debounce";
import useEventListener from "./useEventListener";

/**
 * Adds debounce to event listener
 */
export default function useDebouncedEventListener(event: string, handler: (any?) => any, wait: number = 250) {
    const debouncedMethod = () => debounce(handler, wait)
    useEventListener(event, debouncedMethod())
}